import { ReactIcon } from '@/components/react/ui/ReactIcon';
import { cva, cx, type VariantProps } from '@/cva.config';
import type { ComponentProps, ComponentPropsWithRef } from 'react';

export const carouselArrowButtonVariants = cva({
  base: 'border-blurb-border-subtle bg-blurb-bg-neutral flex items-center justify-center rounded-full border p-1.75 box-content cursor-pointer hover:border-transparent hover:button-shadow-blurb-bg-accent-blue',
  variants: {
    direction: {
      prev: 'embla__prev',
      next: 'embla__next',
    },
    disabled: {
      false: null,
      true: ['pointer-events-none'],
    },
    position: {
      overlaySlides: 'absolute top-1/2 -translate-y-1/2',
      belowSlides: '',
      aboveSlides: '',
    },
    theme: {
      light: 'text-icon-inverse',
      dark: 'text-icon-bold',
    },
  },
  compoundVariants: [
    {
      direction: 'prev',
      position: 'overlaySlides',
      class: 'left-2',
    },
    {
      direction: 'next',
      position: 'overlaySlides',
      class: 'right-2',
    },
  ],
});

interface ReactCarouselArrowButtonProps
  extends ComponentPropsWithRef<'button'>,
    VariantProps<typeof carouselArrowButtonVariants> {
  className?: string;
  direction: 'prev' | 'next';
  disabled?: boolean;
  iconShape?: 'arrow' | 'chevron' | undefined;
  size?: ComponentProps<typeof ReactIcon>['size'];
}

export const ReactCarouselArrowButton = ({
  className,
  direction,
  disabled = false,
  iconShape = 'arrow',
  position,
  size = 'small',
  theme,
  ...props
}: ReactCarouselArrowButtonProps) => (
  <button
    aria-label={`${direction === 'prev' ? 'Previous' : 'Next'} slide`}
    className={cx(
      carouselArrowButtonVariants({ direction, disabled, position, theme }),
      className,
    )}
    disabled={disabled}
    {...props}
  >
    {direction === 'prev' ?
      <ReactIcon
        name={iconShape === 'arrow' ? 'arrowBack' : 'chevronLeft'}
        size={size}
      />
    : <ReactIcon
        name={iconShape === 'arrow' ? 'arrowForward' : 'chevronRight'}
        size={size}
      />
    }
  </button>
);
